import { render, staticRenderFns } from "./SimulasiGadai.vue?vue&type=template&id=2121ffa3&scoped=true&"
import script from "./SimulasiGadai.vue?vue&type=script&lang=js&"
export * from "./SimulasiGadai.vue?vue&type=script&lang=js&"
import style0 from "./SimulasiGadai.vue?vue&type=style&index=0&id=2121ffa3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2121ffa3",
  null
  
)

export default component.exports